import { AppId } from '@inno-tools/container-bridge'
import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { UpdatePinnedAppsOrderResponse } from './updatePinnedAppsOrder.types'

export const updatePinnedAppsOrder = async (appIds: AppId[]) => {
  const response = await containerApi.post<UpdatePinnedAppsOrderResponse>(
    '/desktop/pinned-apps',
    {
      app_ids: appIds
    }
  )
  return response.data
}

export const useUpdatePinnedAppsOrderMutation = (
  options?: ExtendableMutationOptions<UpdatePinnedAppsOrderResponse, AppId[]>
) => {
  return useMutation({
    mutationFn: updatePinnedAppsOrder,
    ...options
  })
}
